export enum PreparationStatus {
    PENDING = 'Pending',
    IN_PREPARATION = 'In Preparation',
    READY = 'Ready'
}

export enum MeasureType {
    AREA = 'Area',
    DEPTH = 'Depth',
    DIAMETER = 'Diameter',
    HEIGHT = 'Height',
    LENGTH = 'Length',
    PACKAGE_UNITS = 'PackageUnits',
    THICKNESS = 'Thickness',
    VOLUME = 'Volume',
    WEIGHT = 'Weight',
    WIDTH = 'Width'
}

export type Measure = {
    type: MeasureType
    units: number
    unitTypeId: string
}
